import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBj8Tcy7oh0wgYxhGgsJC_nSd2Om_G3Yao",
    authDomain: "portfolio-website-deb64.firebaseapp.com",
    projectId: "portfolio-website-deb64",
    storageBucket: "portfolio-website-deb64.appspot.com",
    messagingSenderId: "754297899679",
    appId: "1:754297899679:web:68a133f954d5e9a87bb0aa",
    measurementId: "G-BTG82JHW5S"
});

const db = firebaseApp.firestore();

export default db;